import React from 'react';
import { showBarcodeModal } from '../../../../actionCreators/common';
import Button from '../../../../CommonComponents/BootstrapComponents/Button/Button';
import { connect } from 'react-redux';
import './QrScannerCTA.scss';
const QrScannerCTA = props => {
  const {
    showBarcodeModal,
    dataLocale,
    dataLocale: { SCAN_A_PRODUCT_BARCODE },
  } = props;

  const triggerDataLayerOnCtaClick = () => {
    if (window.mobileGA.LenskartRewamp) {
      window.mobileGA.LenskartRewamp.Search.load.scanProduct();
    }
  };
  return (
    <Button className="w-100 btn-border" onClick={() => {triggerDataLayerOnCtaClick();showBarcodeModal(true)}}>
      <img
        alt="QR Scanner"
        className="mr-b4 mr-r4"
        height="15"
        src="https://static1.lenskart.com/media/desktop/img/DesignStudioIcons/QrScanner.svg"
        width="15"
      />
      {SCAN_A_PRODUCT_BARCODE}
    </Button>
  );
};

const mapStateToProps = state => ({
  dataLocale: state.locale,
});

function mapDispatchToProps(dispatch) {
  return {
    showBarcodeModal: data => dispatch(showBarcodeModal(data)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(QrScannerCTA);
